export default __webpack_public_path__ + "static/media/vip9_right.b78fa70e.webp";